import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import InternalLayout from "app/layouts";
import DailyActivity from "../containers/DailyActivity";
import Imports from "../containers/Imports";
import Notifications from "../containers/Notifications";
import VechileStatuses from "../containers/VechileStatuses";
import Home from "../containers/Home";
import WorkOrder from "../containers/WorkOrder";
import WorkOrderDetails from "../containers/WorkOrder/components/WorkOrderDetails";
import Quotes from "../containers/Quotes";
import Customers from "../containers/Customers";
import CustomerDetails from "../containers/Customers/components/CustomerDetails";
import Profile from "app/containers/Profile";
import Manufacturer from "app/containers/Manufacturer";
import ManufacturerModel from "app/containers/ManufacturerModel";
import ModelDetails from "app/containers/ManufacturerModel/components/ModelDetails";
import FrontClearance from "app/containers/FrontClearance";
import Registration from "app/containers/Registration";
import SuperModel from "app/containers/SuperModel";
import ChassisHeight from "app/containers/ChassisHeight";
import BodyType from "app/containers/BodyType";
import FloorType from "app/containers/FloorType";
import RoofType from "app/containers/RoofType";
import HydraulicWall from "app/containers/HydraulicWall";
import TireType from "app/containers/TireType";
import UnderCarriage from "app/containers/UnderCarriage";
import BackWallType from "app/containers/BackWallType";
import RoofMaterialType from "app/containers/RoofMaterialType";
import HydraulicManufacturer from "app/containers/HydraulicManufacturer";
import Items from "app/containers/Items";
import GlobalParameter from "app/containers/GlobalParameter";
import Inventory from "../containers/Inventory";
import AdminTemplate from "../containers/adminTemplates";
import AdminCatalog from "../containers/AdminCatalog";
import CatalogDetails from "../containers/AdminCatalog/components/CatalogTable/CatalogItems";
import AdminPrice from "../containers/AdminPrice";
import Forms from "../containers/Forms";
import AdminManagement from "../containers/AdminMangment";
import Index from "../containers/AdminMangment/components/UserDetailes";

import Suppliers from "../containers/Suppliers";

export function InterNalRoutes() {
  return (
    <Routes>
      <Route element={<InternalLayout />}>
        <Route index element={<Navigate to="/home" replace />} />
        <Route path="profile" element={<Profile />} />
        <Route path="users" element={<AdminManagement />} />
        <Route path="users/:id" element={<Index/>} />
        <Route path="daily-activity" element={<DailyActivity />} />
        <Route path="vehicle-statuses" element={<VechileStatuses />} />
        <Route path="push-notification" element={<Notifications />} />
        <Route path="imports/*" element={<Imports />} />
        <Route path="dashboard/*" element={<Navigate to="/home" replace />} />
        <Route path="home" element={<Home />} />
        <Route path="work-orders" element={<WorkOrder />} />
        <Route path="work-orders/:id" element={<WorkOrderDetails />} />
        <Route path="quotes" element={<Quotes />} />
        <Route path="quotes/:quoteId" element={<Quotes />} />
        <Route path="customers" element={<Customers />} />
        <Route path="customers/:id" element={<CustomerDetails />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="forms" element={<Forms />} />
        <Route path="Inventory" element={<Inventory />} />
        <Route path="Document-templates" element={<AdminTemplate />} />
        <Route path="catalogs" element={<AdminCatalog />} />
        <Route path="catalogs/:id" element={<CatalogDetails />} />
        <Route path="price-tables" element={<AdminPrice />} />
        <Route path="Suppliers" element={<Suppliers />} />
        <Route path="global-parameters" element={<GlobalParameter />} />
        <Route path="system-tables/manufacturers" element={<Manufacturer />} />
        <Route
          path="system-tables/model-per-manufacturer"
          element={<ManufacturerModel />}
        />
        <Route
          path="system-tables/model-per-manufacturer/:id"
          element={<ModelDetails />}
        />
        <Route
          path="system-tables/front-clearance"
          element={<FrontClearance />}
        />
        <Route
          path="system-tables/registration-instructions"
          element={<Registration />}
        />
        <Route path="system-tables/master-model" element={<SuperModel />} />
        <Route
          path="system-tables/chassis-height"
          element={<ChassisHeight />}
        />
        <Route path="system-tables/body-type" element={<BodyType />} />
        <Route path="system-tables/floor-type" element={<FloorType />} />
        <Route path="system-tables/roof-type" element={<RoofType />} />
        <Route
          path="system-tables/hydraulic-tailgate-type"
          element={<HydraulicWall />}
        />
        <Route path="system-tables/tire-type" element={<TireType />} />
        <Route
          path="system-tables/sub-chassis-type"
          element={<UnderCarriage />}
        />
        <Route
          path="system-tables/rear-wall-type"
          element={<BackWallType />}
        />
        <Route
          path="system-tables/roof-material-type"
          element={<RoofMaterialType />}
        />
        <Route
          path="system-tables/hydraulic-tailgate-manufacturer"
          element={<HydraulicManufacturer />}
        />
        <Route path="system-tables/items" element={<Items />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Route>
    </Routes>
  );
}
